"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = returnFalse;
function returnFalse() {
    return false;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-custom-scrollbars/lib/utils/returnFalse.js
 ** module id = 961
 ** module chunks = 0
 **/